export default `
  font-family: 'Scto Grotesk A', sans-serif;
  font-weight: 500;
`
